<template>
  <div>
    <a-switch size="large" @change="onWeekendToggleChange" :checked="showWeekend" class="mr-2" /><span
      class="text-base"
      >{{ $t("showWeekend") }}</span
    >
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useBoardStore } from "@/store/board/BoardStore";
import { useBrickStore } from "@/store/brick/BrickStore";
import { useFleetStore } from "@/store/fleet/FleetStore";

export default defineComponent({
  name: "ShowWeekend",
  setup(props, { emit }) {
    const boardStore = useBoardStore();
    const brickStore = useBrickStore();
    const fleetStore = useFleetStore();

    const showWeekend = computed(() => useBoardStore().showWeekends);

    const onWeekendToggleChange = async () => {
      emit("isLoading", true);
      await boardStore.toggleShowWeekends();
      boardStore.setBoard();
      await boardStore.updateConfigProfile();
      await fleetStore.clearFleet();
      await brickStore.resetLegs();
      await brickStore.resetFleetActions();
      await fleetStore.fetchBoardFleet();
      emit("isLoading", false);
    };
    return {
      onWeekendToggleChange,
      showWeekend
    };
  }
});
</script>

<style scoped></style>
